import React from 'react';
import Search from 'Components/DesignSystem/Search/Search';

type SearchBarProps = {
    value: string;
    onChange: (value: string) => void;
    /**
     * § 288 — a search is in flight, or its 500ms debounce is still running. The
     * caller owns the expression: this wrapper is mounted by two different screens,
     * each keyed on a different tab's fetch, and neither fact is derivable here.
     */
    loading?: boolean;
    /** Announced by the spinner (`role="status"`), visually hidden. */
    loadingLabel?: string;
};

const SearchBar = ({ value, onChange, loading = false, loadingLabel }: SearchBarProps) => {
    return (
        <Search
            value={value}
            onChange={(val) => onChange(val)}
            loading={loading}
            loadingLabel={loadingLabel}
            placeholder="Search"
            searchIconPosition="end"
            className="tw-w-96"
            data-testid="category-relevancy-search-input"
        />
    );
};

export default SearchBar;
